import { Component, OnInit } from '@angular/core';
import { PatientSocialHistoryModel, ItemList, severtydropdownListt, IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { IntakeAllergyService } from 'src/app/services/intake-Allergy.service';
import { Router } from '@angular/router';
import { IntakeSocialService } from 'src/app/services/intake-Social.service';
import { SocialHistoryModel } from 'src/app/models/intake/SocialHistory';
import { IntakeService } from 'src/app/services/intake.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-social-history',
  templateUrl: './social-history.component.html',
  styleUrls: ['./social-history.component.css']
})
export class SocialHistoryComponent implements OnInit {
  private subscription: Subscription;
  selected_objPatientSocialHistory: PatientSocialHistoryModel = new PatientSocialHistoryModel();
  objPatientSocialHistory: PatientSocialHistoryModel = new PatientSocialHistoryModel();
  tobaccoStatusDropdownList: any = [];
  tobaccoDateError = "";
  industoryDateError = "";
  readonly _IP_Address = "127.0.0.1";
  patientpersonalinfo: any;
  PMH_Temp: any = [];
  reactiondropdownList: ItemList[] = [];
  itemList: ItemList = new ItemList();
  severtydropdownListt: severtydropdownListt;
  severtydropdownList: any = [];
  relationShipDropdownList: any = [];
  alcoholUsageDayDropdownList: any = [];
  seatbeltDropdownList: any = [];
  exerciseDropdownList: any = [];
  drugUseDropdownList: any = [];
  exposureDropdownList: any = [];
  highestEducationDropdownList: any = [];
  industryDropdownList: any = [];
  curDate = new Date();
  translatedText: any;
  intakeFieldsSetting: IntakeFieldsSetting=new IntakeFieldsSetting();
  constructor(private _phrutilService: PhrutillsService, private spinner: NgxSpinnerService, private _intakedService: IntakeAllergyService
    , private route: Router, private datepipe: DatePipe, private _intakedSocialService: IntakeSocialService, private _intake: IntakeService, private translate: TranslateService) { 
      let info = localStorage.getItem('PersonalInfo');
      if(!info){
        this.route.navigateByUrl("/");
        return;
      }
  }

  getTranslatedTextTobaccoStatus(value: string) {
    // Use the translation service to get the translated value
    this.translatedText = "";
    let translateString = "";
    //
    if (value == "Current every day smoker") {
      translateString = 'social_history.social_history_tobacco_status_current_every_day_smoker'
    } else if (value == "Current some day smoker") {
      translateString = 'social_history.social_history_tobacco_status_current_some_day_smoker'
    } else if (value == "Former smoker") {
      translateString = 'social_history.social_history_tobacco_status_former_smoker'
    } else if (value == "Never smoker") {
      translateString = 'social_history.social_history_tobacco_status_never_smoker'
    } else if (value == "Smoker^ current status unknown") {
      translateString = 'social_history.social_history_tobacco_status_smoker_current_status_unknown'
    } else if (value == "Unknown if ever smoked") {
      translateString = 'social_history.social_history_tobacco_status_unknown_if_ever_smoked'
    } else if (value == "Heavy tobacco smoker") {
      translateString = 'social_history.social_history_tobacco_status_heavy_tobacco_smoker'
    } else if (value == "Light tobacco smoker") {
      translateString = 'social_history.social_history_tobacco_status_light_tobacco_smoker'
    }

    this.translate.get(translateString).subscribe((res: string) => {
      this.translatedText = res;
     // console.log(this.translatedText); // Output the translated string
    });
    return this.translatedText;
  }

  getTranslatedTextAlcoholUsage(value: string) {
    this.translatedText = "";  // Assuming this is a class property
    let translateString = "";

    // Map alcohol usage options to translation keys
    switch (value) {
      case "Don't drink alcohol":
        translateString = 'social_history.social_history_alcohol_usage_dont_drink';
        break;
      case "Social Drinker":
        translateString = 'social_history.social_history_alcohol_usage_social_drinker';
        break;
      case "1-2 Drinks/Day":
        translateString = 'social_history.social_history_alcohol_usage_1_2_drinks_day';
        break;
      case "3-5 Drinks/Day":
        translateString = 'social_history.social_history_alcohol_usage_3_5_drinks_day';
        break;
      case "More Than 5 Drinks/Day":
        translateString = 'social_history.social_history_alcohol_usage_more_than_5_drinks_day';
        break;
      case "5-10 Drinks/week":
        translateString = 'social_history.social_history_alcohol_usage_5_10_drinks_week';
        break;
      case "10-20 Drinks/week":
        translateString = 'social_history.social_history_alcohol_usage_10_20_drinks_week';
        break;
      case "More Than 20 Drinks/week":
        translateString = 'social_history.social_history_alcohol_usage_more_than_20_drinks_week';
        break;
      default:
        translateString = '';  // No translation available
    }

    // Fetch the translation and update the translatedText
    if (translateString) {
      this.translate.get(translateString).subscribe((res: string) => {
        this.translatedText = res;
       // console.log(this.translatedText); // Output the translated string
      });
    } else {
      console.log("No translation key provided for the selected option.");
    }
    return this.translatedText; // Note: this will still be empty at return time due to asynchronous execution
  }
  getTranslatedTextDrugUsage(value: string) {
    this.translatedText = "";  // Assuming this is a class property
    let translateString = "";

    // Map drug usage options to translation keys
    switch (value) {
      case "Never":
        translateString = 'social_history.social_history_drug_usage_never';
        break;
      case "Remote H/O":
        translateString = 'social_history.social_history_drug_usage_remote_ho';
        break;
      case "IV Drugs":
        translateString = 'social_history.social_history_drug_usage_iv_drugs';
        break;
      case "Non IV Drugs":
        translateString = 'social_history.social_history_drug_usage_non_iv_drugs';
        break;
      default:
        translateString = '';  // No translation available or no match found
    }

    // Fetch the translation and update the translatedText
    if (translateString) {
      this.translate.get(translateString).subscribe((res: string) => {
        this.translatedText = res;
        //console.log(this.translatedText); // Output the translated string
      });
    } else {
      console.log("No translation key provided for the selected option.");
    }
    return this.translatedText; // Note: this will still be empty at return time due to asynchronous execution
  }

  ngOnInit(): void {
    this._phrutilService.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this._phrutilService.setTitle('Historia social');
      } else if (language === 'hi') {
        this._phrutilService.setTitle('सामाजिक इतिहास');
      } else if (language === 'ur') {
        this._phrutilService.setTitle('سوشَل ہسٹری');
      }
      else {
        this._phrutilService.setTitle('Social History');
      }
    });

      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
      this.setIntakeDropDown();
    if (this._intake.subsSaveSocialHistory==undefined) {
      this.subscription = this._intake.invokeSaveSocialHistory.subscribe((name:string) => {
          this.onSubmitPersonalHistory();    
        });    
      }
  }
    onEditHistory() {
      this.tobaccoDateError = "";
      this.industoryDateError = "";
      
      this.selected_objPatientSocialHistory = new PatientSocialHistoryModel();
      this.selected_objPatientSocialHistory = { ...this.objPatientSocialHistory };
      //this.setFeelSafe();
      //document.getElementById("HistoryEditPopup").click();
    }
    setIntakeDropDown() {
      this.spinner.show();
      this._intakedService.GetIntakeDropDownList(this.patientpersonalinfo.PRACTICE_CODE.toString(), this.patientpersonalinfo.PATIENT_ACCOUNT.toString()).subscribe((res:any) => {
        
        this.spinner.hide();
        if (res.statusCode == 200) {
          
          for (let i = 0; i < res.data.pastMedicalHistories.length; i++) {
            this.PMH_Temp.push(res.data.pastMedicalHistories[i])
          }
          
          for (let item of res.data.predefinedForms) {
            if (item.frontLabel == 'Reaction') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.itemList = new ItemList();
                this.itemList.allergyReactionId = splitResult[0];
                this.itemList.allergyReactioNDescription = splitResult[1];
                if (this.itemList.allergyReactionId != '') {
                  this.reactiondropdownList.push(this.itemList);
                }
              }
              this.reactiondropdownList = JSON.parse(JSON.stringify(this.reactiondropdownList));
            } else if (item.frontLabel == 'Severity') {
              let severityList = item.options;
              let severityResult = severityList.split(",");
              for (let item of severityResult) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0]
                this.severtydropdownListt.text = splitResult[1]
                if (this.severtydropdownListt.value != '') {
                  this.severtydropdownList.push(this.severtydropdownListt);
                }
              }
            } else if (item.frontLabel == 'Relationship') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.relationShipDropdownList.push(this.severtydropdownListt);
              }
            } else if (item.frontLabel == 'Tobacco Status') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.tobaccoStatusDropdownList.push(this.severtydropdownListt);
              }
            } else if (item.frontLabel == 'Alcohol Usage/Day') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[1];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.alcoholUsageDayDropdownList.push(this.severtydropdownListt);
              }
            } else if (item.frontLabel == 'Exercise') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.exerciseDropdownList.push(this.severtydropdownListt);
              }
            } else if (item.frontLabel == 'Drug Use') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.drugUseDropdownList.push(this.severtydropdownListt);
              }
            } else if (item.frontLabel == 'Seatbelt') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                this.seatbeltDropdownList.push(this.severtydropdownListt);
              }
            }
            else if (item.frontLabel == 'Exposure') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.exposureDropdownList.push(this.severtydropdownListt);
              }
            }
            else if (item.frontLabel == 'Highest Education') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.highestEducationDropdownList.push(this.severtydropdownListt);
              }
            }
            else if (item.frontLabel == 'Industry') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0];
                this.severtydropdownListt.text = splitResult[1];
                if (this.severtydropdownListt.value != '')
                this.industryDropdownList.push(this.severtydropdownListt);
              }
            }
            
          }
          
        } else {
          let text = "Service is not available, please try later.";
          this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
        
        this.onPatientSocialHistory();
      },
      (error:any) => {
        
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
       // this._phrutilService.showError("Service is not available, please try later.");
        
        this.onPatientSocialHistory();
      });
    }
    onTobaccoDateChange() {
      this.tobaccoDateError = "";
    }
    onChangeFeelSafe(feelSafeFlag: string) {
      this.selected_objPatientSocialHistory.feelsSafe = feelSafeFlag;
      this.setFeelSafe();
    }
    setFeelSafe() {
      
      if (this.selected_objPatientSocialHistory.feelsSafe == "True") {
        (<HTMLInputElement>document.getElementById("FeelSafeYes")).checked = true;
        (<HTMLInputElement>document.getElementById("FeelSafeNo")).checked = false;
        return;
      }
      
      (<HTMLInputElement>document.getElementById("FeelSafeYes")).checked = false;
      (<HTMLInputElement>document.getElementById("FeelSafeNo")).checked = true;
      
    }
    onIndustryDateChange() {
      this.industoryDateError = "";
    }
    onPatientSocialHistory() {
      this.objPatientSocialHistory = new PatientSocialHistoryModel();
      this.spinner.show();
      this._intakedSocialService.GetPatientSocialHistory(this.patientpersonalinfo.PATIENT_ACCOUNT.toString(), this.patientpersonalinfo.PRACTICE_CODE.toString()).subscribe((res:any) => {
        
        this.spinner.hide();
        if (res.statusCode == 200) {
          
          this.objPatientSocialHistory = res.data.socialHistory as PatientSocialHistoryModel;
          if (this.objPatientSocialHistory) {
            this.objPatientSocialHistory.industryStartDate = this.datepipe.transform(this.objPatientSocialHistory.industryStartDate, 'yyyy-MM-dd');
            this.objPatientSocialHistory.industryEndDate = this.datepipe.transform(this.objPatientSocialHistory.industryEndDate, 'yyyy-MM-dd');
            this.objPatientSocialHistory.tobaccoStartDate = this.datepipe.transform(this.objPatientSocialHistory.tobaccoStartDate, 'yyyy-MM-dd');
            this.objPatientSocialHistory.tobaccoEndDate = this.datepipe.transform(this.objPatientSocialHistory.tobaccoEndDate, 'yyyy-MM-dd');
            
            if (this.objPatientSocialHistory.education) {
              this.objPatientSocialHistory.educationDescription = this.objPatientSocialHistory.education.split("|")[1].trim();
              this.objPatientSocialHistory.education = this.objPatientSocialHistory.education.split("|")[0].trim();
            }
            
            if (this.objPatientSocialHistory.industryCode) {
              this.objPatientSocialHistory.industryDescription = this.objPatientSocialHistory.industryCode.split("|")[1].trim();
              this.objPatientSocialHistory.industryCode = this.objPatientSocialHistory.industryCode.split("|")[0].trim();
            }
            
            if (this.objPatientSocialHistory.tobaccoStatus) {
              this.objPatientSocialHistory.tobaccoStatusCode = this.objPatientSocialHistory.tobaccoStatus.split("|")[0];
              this.objPatientSocialHistory.tobaccoStatus = this.objPatientSocialHistory.tobaccoStatus.split("|")[1];
            } else {
              this.objPatientSocialHistory.tobaccoStatusCode = "";
            }
            
            
            this.onEditHistory();
            this.GetIntakeformFieldsSettings();
            
          }
        } else {
          let text = "Service is not available, please try later.";
          this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError('Service is not available, please try later.');
        }
      },
      (error:any) => {
        
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
  onSubmitPersonalHistory() {

      if (!this.selected_objPatientSocialHistory.tobaccoStartDate) {
        this.selected_objPatientSocialHistory.tobaccoStartDate = "";
      }
      
      if (!this.selected_objPatientSocialHistory.tobaccoEndDate) {
        this.selected_objPatientSocialHistory.tobaccoEndDate = "";
      }
      /*
      if (this.selected_objPatientSocialHistory.tobaccoStartDate) {
        if (this.selected_objPatientSocialHistory.tobaccoEndDate) {
          if (this.selected_objPatientSocialHistory.tobaccoStartDate > this.selected_objPatientSocialHistory.tobaccoEndDate) {
            this.tobaccoDateError = "Tobacco Effective from date must be prior to the Effective to date.";
            return;
          }
          if (this.selected_objPatientSocialHistory.tobaccoStartDate == this.selected_objPatientSocialHistory.tobaccoEndDate) {
            this.tobaccoDateError = "Tobacco Effective from date must be prior to the Effective to date.";
            return;
          }
        }
      }*/
      
      if (!this.selected_objPatientSocialHistory.industryStartDate) {
        this.selected_objPatientSocialHistory.industryStartDate = "";
      }
      
      if (!this.selected_objPatientSocialHistory.industryEndDate) {
        this.selected_objPatientSocialHistory.industryEndDate = "";
      }
      /*
      if (this.selected_objPatientSocialHistory.industryStartDate) {
        if (this.selected_objPatientSocialHistory.industryEndDate) {
          if (this.selected_objPatientSocialHistory.industryStartDate > this.selected_objPatientSocialHistory.industryEndDate) {
            this.industoryDateError = "Industry Effective from date must be prior to the Effective to date.";
            return;
          }
          if (this.selected_objPatientSocialHistory.industryStartDate == this.selected_objPatientSocialHistory.industryEndDate) {
            this.industoryDateError = "Industry Effective from date must be prior to the Effective to date.";
            return;
          }
        }
      }*/
      
      this.onSavePatientSocialHistory();
    }
    
    
  onSavePatientSocialHistory() {
      
      let OBJ_SocialHistory = new SocialHistoryModel();
      
      OBJ_SocialHistory.socialHistoryId = this.selected_objPatientSocialHistory.socialhxId;
      OBJ_SocialHistory.tobacoStatusIdPk = this.selected_objPatientSocialHistory.tobaccoStatusCode;
      OBJ_SocialHistory.tobacoStatusId = this.selected_objPatientSocialHistory.tobaccoStatusCode;
      OBJ_SocialHistory.riskAssessmentId = this.selected_objPatientSocialHistory.riskAssessmentStructId;
      OBJ_SocialHistory.practiceCode = this.patientpersonalinfo.PRACTICE_CODE.toString();
      OBJ_SocialHistory.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
      OBJ_SocialHistory.educationId = this.selected_objPatientSocialHistory.education;
      OBJ_SocialHistory.tobacoStatus = this.selected_objPatientSocialHistory.tobaccoStatus;
      OBJ_SocialHistory.tobacoStartDate = this.selected_objPatientSocialHistory.tobaccoStartDate;
      OBJ_SocialHistory.tobacoEndDate = this.selected_objPatientSocialHistory.tobaccoEndDate;
      OBJ_SocialHistory.alcohalPerDay = this.selected_objPatientSocialHistory.alcoholDay;
      OBJ_SocialHistory.alcohalUsage = this.selected_objPatientSocialHistory.alcoholDay;
      OBJ_SocialHistory.drugUse = this.selected_objPatientSocialHistory.drugUse;
      OBJ_SocialHistory.industryCode = this.selected_objPatientSocialHistory.industryCode;
      OBJ_SocialHistory.industryStartDate = this.selected_objPatientSocialHistory.industryStartDate;
      OBJ_SocialHistory.industryEndDate = this.selected_objPatientSocialHistory.industryEndDate;
      OBJ_SocialHistory.exercise = this.selected_objPatientSocialHistory.exercise;
      OBJ_SocialHistory.seatBelts = this.selected_objPatientSocialHistory.seatbelts;
      OBJ_SocialHistory.exposure = this.selected_objPatientSocialHistory.exposure;
      OBJ_SocialHistory.feels_Safe = this.selected_objPatientSocialHistory.feelsSafe == 'True' ? 'YES' : 'NO';
      OBJ_SocialHistory.howLongUsingTobaco = this.selected_objPatientSocialHistory.notes;
      OBJ_SocialHistory.caffineUsage = this.selected_objPatientSocialHistory.caffineUsage;
      OBJ_SocialHistory.drugUseDetails = this.selected_objPatientSocialHistory.drugUseDetails;
      OBJ_SocialHistory.ipAddress = this._IP_Address;
      
      // dashboard intake form start
      
      if (OBJ_SocialHistory.caffineUsage == undefined || OBJ_SocialHistory.caffineUsage == '' || OBJ_SocialHistory.caffineUsage == null) {
        OBJ_SocialHistory.caffineUsage = "0";
      }
      
      if (OBJ_SocialHistory.drugUseDetails == undefined || OBJ_SocialHistory.drugUseDetails == '' || OBJ_SocialHistory.drugUseDetails == null) {
        OBJ_SocialHistory.drugUseDetails = "0";
      }
      
      if (OBJ_SocialHistory.alcohalUsage == undefined || OBJ_SocialHistory.alcohalUsage == '' || OBJ_SocialHistory.alcohalUsage == null) {
        OBJ_SocialHistory.alcohalUsage = "0";
      }
      
      if (OBJ_SocialHistory.socialHistoryId == undefined || OBJ_SocialHistory.socialHistoryId == '' || OBJ_SocialHistory.socialHistoryId == null) {
        OBJ_SocialHistory.socialHistoryId = "-1";
      }
      if (OBJ_SocialHistory.riskAssessmentId == undefined || OBJ_SocialHistory.riskAssessmentId == '' || OBJ_SocialHistory.riskAssessmentId == null ) {
        OBJ_SocialHistory.riskAssessmentId = "-1";
      }
      
      //dashboard intake form end
      
      
      OBJ_SocialHistory.request = [];
      OBJ_SocialHistory.request.push({
        patientIntakeFormsId: "565101",
        patientIntakeFormsName: "Template",
        intakeFormQuestionId: "544125",
        sectionName: "Allergy",
        columnType: "DROPDOWN",
        options: ""
      });
      
      OBJ_SocialHistory.pmh = this.PMH_Temp;
      
      this.spinner.show();
      this._intakedSocialService.SavePatientSocialHistory(OBJ_SocialHistory).subscribe((res:any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          //this._phrutilService.showSuccess("Social History saved successfully");

          this.route.navigateByUrl("/patient/intake/past-surgical-history");
          this._intake.onNextStepSurgicalHistory();
        }
        else {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      }, (error:any) => {
        //document.getElementById("closePatientPersonalHistory").click();
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
      
    }
    GetIntakeformFieldsSettings() {
      
      this.intakeFieldsSetting = this._phrutilService.decrypt(localStorage.getItem("intakeformsetting"));
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log("Unsubscribed from invokeSaveSocialHistory.");
    }
  }
  }
